// extracted by mini-css-extract-plugin
export default {"fields":"wb3cv7","gaps":"edntoF","time":"gHjELD","mobile":"k1AML_"};